import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-hot-toast';
import API from '../../Services/API';

export const LoadDashBoardStats = createAsyncThunk(
  'general/dashboard/stats',
  async (data, { rejectWithValue }) => {
    const url = process.env.REACT_APP_API_URL;
    const params = {
      company_id: data.companyId || process.env.REACT_APP_COMP_EMM
    };
    try {
      const res = await API().get(`${url}/dashboard/vendors/${data.vendNo}`, { params });
      return res.data;
    } catch (e) {
      toast.error(e.response.data);
      return rejectWithValue(e.response.data);
    }
  }
);

export const LoadDashBoardFeeds = createAsyncThunk(
  'general/dashboard/feeds',
  async (data, { rejectWithValue }) => {
    const params = {
      company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
      $filter: `vendorNo eq '${data.vendNo}'`,
      $count: true,
      $top: 6
    };
    const url = process.env.REACT_APP_API_URL;
    try {
      const res = await API().get(`${url}/dashboard/feeds`, { params });
      return res.data;
    } catch (e) {
      toast.error(e.response.data);
      return rejectWithValue(e.response.data);
    }
  }
);

export const LoadFeedbackLoopStatus = createAsyncThunk(
  'general/feedback/status',
  async (data, { rejectWithValue }) => {
    const url = process.env.REACT_APP_API_URL;
    try {
      const res = await API().get(`${url}/feedback-loop-status`);
      return res.data;
    } catch (e) {
      toast.error(e.response.data);
      return rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  TOCount: 0,
  chart: [],
  feeds: [],
  loadingStats: false,
  isFeedBackLoopEnabled: false
};

const GeneralSlice = createSlice({
  name: 'general',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(LoadDashBoardStats.pending, (state, { payload }) => {
      return {
        ...initialState,
        loadingStats: true
      };
    });
    builder.addCase(LoadDashBoardStats.fulfilled, (state, { payload }) => {
      const chartData = payload.vpCharts.map((info) => {
        return {
          label: info.date,
          PO: info.PO,
          TO: info.TO
        };
      });
      // payload.POWHCount/POVendCount are intentionally ignored - see OrderSlice's
      // LoadDashBoardOpenPOs for the PO count shown on the dashboard.
      return {
        ...state,
        loadingStats: false,
        TOCount: payload.TOCount,
        chart: chartData.sort(function (a, b) {
          return new Date(a.label) - new Date(b.label);
        })
      };
    });
    builder.addCase(LoadDashBoardFeeds.fulfilled, (state, { payload }) => {
      return {
        ...state,
        loadingStats: false,
        feeds: payload.value.map((feed) => {
          return {
            docNo: feed.docNo,
            docType: feed.docType
          };
        })
      };
    });
    builder.addCase(LoadFeedbackLoopStatus.fulfilled, (state, { payload }) => {
      return {
        ...state,
        isFeedBackLoopEnabled: !!(payload && payload.enabled)
      };
    });
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default GeneralSlice.reducer;
export const GeneralActions = GeneralSlice.actions;
